<template>
  <div class="dashboard">
    <div class="connectors-use-status dashboard-block">
      <div class="title">
        充電樁使用狀況
      </div>
      <div class="block-wrap">
        <div class="connectors-status block">
          <div class="block-title">
            充電樁狀態
          </div>
          <div class="block-content">
            <div class="left doughnut-wrap">
              <div class="doughnut">
                <div class="doughnut-middle-text">
                  <div class="num">
                    {{ statusSun }}
                  </div>
                  <div class="description">
                    充電樁總數
                  </div>
                </div>
                <Doughnut v-if="tabActive && !pageLoading" class="chart" :style="`height:250`" :height="250" :width="250" :chart-data="statusData" />
              </div>
            </div>
            <div class="right">
              <!-- 狀態list -->
              <div class="status-list">
                <div v-for="i in statusData.datasets[0].data.length" :key="i" class="status-item connectors-use-status-item">
                  <div class="label">
                    <div class="label-color" :style="`background-color: ${statusData.datasets[0].backgroundColor[i-1]};`"></div>
                    <div class="label-name">
                      {{ statusData.labels[i-1] }}
                      <el-popover
                        v-if="statusData.labels[i-1] === '異常'"
                        :visible-arrow="false"
                        placement="bottom-start"
                        width="150"
                        trigger="click"
                        @hide="errorCollapse = false"
                      >
                        <div>
                          <div v-for="errItem in statusErrorDefine" :key="errItem.name" class="error-item" :style="`display: flex; justify-content: space-between;`">
                            <div class="error-label">
                              {{ errItem.label }}
                            </div>
                            <div class="error-data">
                              {{ summaryData.byStatus[errItem.name] }}
                            </div>
                          </div>
                        </div>
                        <i
                          slot="reference"
                          :class="[ errorCollapse ? 'icon-toggle-up' : 'icon-toggle-down' ]" @click="errorCollapse = !errorCollapse"
                        ></i>
                      </el-popover>
                    </div>
                  </div>
                  <div class="num">
                    {{ statusData.datasets[0].data[i-1] }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="maintenance-status block">
          <div class="block-title">
            維護控管
          </div>
          <div class="block-content">
            <div class="left doughnut-wrap">
              <div class="doughnut">
                <div class="doughnut-middle-text">
                  <div class="num">
                    {{ maintenanceSum }}
                  </div>
                  <div class="description">
                    充電樁總數
                  </div>
                </div>
                <Doughnut v-if="tabActive && !pageLoading" class="chart" :style="`height:250`" :height="250" :width="250" :chart-data="maintenanceData" />
              </div>
            </div>
            <div class="right">
              <!-- 狀態list -->
              <div class="status-list">
                <div v-for="i in maintenanceData.datasets[0].data.length" :key="i" class="status-item maintenance-status-item">
                  <div class="label">
                    <div class="label-color" :style="`background-color: ${maintenanceData.datasets[0].backgroundColor[i-1]};`"></div>
                    <div class="label-name">
                      {{ maintenanceData.labels[i-1] }}
                    </div>
                  </div>
                  <div class="num">
                    {{ maintenanceData.datasets[0].data[i-1] }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dashboard-block">
      <DistributionBoard :charging-feature="chargingFeature" />
    </div>
    <!-- 先暫時不提供統計圖 -->
    <!-- <div class="dashboard-block">
      <div class="title">
        {{ $t('EvCharging.DistributionInfo') }}
      </div>
      <div>
        <DistributionBoardCharts />
      </div>
    </div> -->
    <div class="ampere-detail dashboard-block">
      <div class="head">
        <div class="title" @click="showPowerUsage = !showPowerUsage">
          社區每日用電量<i :class="[showPowerUsage ? 'icon-arrow-down' : 'icon-arrow-right2']"></i>
        </div>
        <el-button v-show="showPowerUsage" class="day-btn hide-input" size="mini" @click="showDatePicker">
          {{ pickerDate }}
          <el-date-picker
            ref="datePicker"
            v-model="pickerDate"
            type="date"
            :clearable="false"
            prefix-icon="''"
            value-format="yyyy/MM/dd"
            format="yyyy/MM/dd"
            :editable="false"
            :picker-options="pickerOptions"
            placeholder="選擇日期"
          >
          </el-date-picker>
        </el-button>
      </div>
      <div v-if="showPowerUsage" class="block-wrap block-wrap-overflow">
        <div class="test-wrap block">
          <div class="block-title">
            度數/小時
          </div>
          <div v-loading="powerUsageLoading" class="bar-wrap">
            <Bar v-if="tabActive && !pageLoading" class="chart" :style="`height:300`" :height="200" :width="1800" :chart-data="ampereDetailData" />
          </div>
        </div>
      </div>
    </div>
    <div v-if="chargingFeature.HasDistributor" class="dashboard-block">
      <div class="title">
        {{ $t('EvCharging.NoticeAndAbnormalList') }}
      </div>
      <NotificationList :charging-feature="chargingFeature" />
    </div>
  </div>
</template>

<script>
import Doughnut from '../components/chart/Doughnut.vue'
import DistributionBoard from '../components/DistributionBoard.vue'
import NotificationList from '../components/NotificationList.vue'
import Bar from '../components/chart/Bar.vue'
import { apiEvCharging } from '@/api/EvCharging'
import { defaultPoserUsageData, defaultDoughnutStatusData, defaultDoughnutMaintenanceData } from '../utils'

export default {
  components: {
    Doughnut,
    DistributionBoard,
    NotificationList,
    Bar
  },
  props: {
    activeTabName: {
      type: String,
      default: ''
    },
    chargingFeature: {
      type: Object,
      required: false
    }
  },
  data () {
    const today = new Date()
    const yesterday = today.setDate(today.getDate() - 1)
    const value = dayjs(new Date(yesterday)).format('YYYY/MM/DD')
    return {
      pageLoading: true,
      interval: null,
      // 社區每日用電量 使用
      showPowerUsage: false,
      powerUsageLoading: false,
      pickerOptions: {
        disabledDate: this.disabledDate
      },
      pickerDate: value,
      powerUsageData: '',

      summaryData: {
        byMaintenance: {
          Normal: 0,
          InMaintenance: 0
        },
        byStatus: {
          Available: 0,
          Preparing: 0,
          Charging: 0,
          Finishing: 0,
          Unavailable: 0,
          Faulted: 0,
          Offline: 0,
          Emergency: 0
        }
      },
      statusDefine: [
        { label: '閒置中', name: 'Available', dataIndex: 0 },
        { label: '準備中', name: 'Preparing', dataIndex: 1 },
        { label: '充電中', name: 'Charging', dataIndex: 2 },
        { label: '停止充電', name: 'Finishing', dataIndex: 3 },
        { label: '異常', name: 'error', dataIndex: 4 }
      ],
      statusErrorDefine: [
        { label: '無法使用', name: 'Unavailable' },
        { label: '發生錯誤', name: 'Faulted' },
        { label: '離線中', name: 'Offline' },
        { label: '緊急停止', name: 'Emergency' }
      ],
      maintenanceDefine: [
        { label: '正常', name: 'Normal', dataIndex: 0 },
        { label: '維護', name: 'InMaintenance', dataIndex: 1 }
      ],
      statusData: {
        labels: ['閒置中', '準備中', '充電中', '停止充電', '異常'],
        datasets: [
          {
            backgroundColor: ['#CCCCCC', '#388cbb', '#419f7d', '#ffce2b', '#c44536'],
            data: defaultDoughnutStatusData
          }
        ]
      },
      maintenanceData: {
        labels: ['正常', '維護'],
        datasets: [
          {
            backgroundColor: ['#419f7d', '#c44536'],
            data: defaultDoughnutMaintenanceData
          }
        ]
      },
      errorCollapse: false,
      ampereDetailData: {
        labels: [
          '00:00', '01:00', '02:00', '03:00', '04:00', '05:00',
          '06:00', '07:00', '08:00', '09:00', '10:00', '11:00',
          '12:00', '13:00', '14:00', '15:00', '16:00', '17:00',
          '18:00', '19:00', '20:00', '21:00', '22:00', '23:00'
        ],
        datasets: [
          {
            label: 'Data One',
            backgroundColor: '#419f7d',
            data: defaultPoserUsageData
          }
        ]
      }

    }
  },

  computed: {
    tabActive () { // chart在開啟儀表板tab時才渲染，避免渲染高度、寬度錯誤問題
      return this.activeTabName === 'chargingDashboard'
    },
    statusSun () {
      return Object.values(this.summaryData.byStatus).reduce((a, b) => a + b, 0)
    },
    maintenanceSum () {
      return Object.values(this.summaryData.byMaintenance).reduce((a, b) => a + b, 0)
    }
  },
  watch: {
    activeTabName (newValue) {
      if (newValue === 'chargingDashboard') this.refreshDataInterval()
      else clearInterval(this.interval)
    },
    showPowerUsage (newValue) {
      if (newValue) {
        this.getPoserUsage()
      }
    },
    pickerDate () {
      this.getPoserUsage()
    }
  },
  mounted () {
    this.refreshDataInterval()
  },
  destroyed () {
    if (this.interval) clearInterval(this.interval)
  },
  methods: {
    showDatePicker () {
      this.$refs.datePicker.showPicker()
    },
    refreshDataInterval () {
      this.getConnectorsSummary()
      if (this.interval) clearInterval(this.interval)
      this.interval = setInterval(() => this.getConnectorsSummary(), 60 * 1000)
    },
    getConnectorsSummary () {
      apiEvCharging.DashBoard.getConnectorsSummary().then(res => {
        this.summaryData.byStatus = { ...this.summaryData.byStatus, ...res.data.Data.ByStatus }
        this.summaryData.byMaintenance = { ...this.summaryData.byMaintenance, ...res.data.Data.ByMaintenance }
        this.formatStatusData(res.data.Data.ByStatus)
        this.formatMaintenanceData(res.data.Data.ByMaintenance)

        this.pageLoading = false
      }).catch(err => {
        console.log(err)
        this.pageLoading = false
      })
    },
    getPoserUsage () {
      const date = this.pickerDate
      if (!date) return
      this.powerUsageLoading = true
      apiEvCharging.DashBoard.getPowerUsage({ Date: date }).then(res => {
        this.formatPoserUsageChart(res.data.Data.History)
        this.powerUsageLoading = false
      }).catch(err => {
        console.log(err)
        this.powerUsageLoading = false
      })
    },
    formatPoserUsageChart (data) {
      if (!data) return
      const temp = _cloneDeep(defaultPoserUsageData)
      data.forEach(o => {
        if (typeof o.Hour === 'number' && typeof o.PowerUsage === 'number') {
          const powerUsage = Math.round(o.PowerUsage * 100) / 100
          temp[o.Hour] = powerUsage
        }
      })
      this.ampereDetailData.datasets[0].data = temp
    },
    disabledDate (time) { // 只能搜尋昨天～2個月前的資料
      return dayjs(time).isBefore(dayjs().subtract(2, 'month'), 'date') || dayjs(time).isAfter(dayjs().subtract(1, 'day'), 'date')
    },
    formatStatusData (statueData) {
      this.statusData.datasets[0].data[4] = 0 // 重置異常狀態的資料
      const temp = _cloneDeep(defaultDoughnutStatusData)

      for (const [key, value] of Object.entries(statueData)) {
        const statusItem = this.statusDefine.find(o => key === o.name)
        if (statusItem) {
          temp[statusItem.dataIndex] = value
        } else {
          // 定義異常的(statusErrorDefine) 歸到「異常」類別
          temp[4] += value // 異常
        }
      }
      this.statusData.datasets[0].data = temp
    },
    formatMaintenanceData (maintenanceData) {
      const temp = _cloneDeep(defaultDoughnutMaintenanceData)
      for (const [key, value] of Object.entries(maintenanceData)) {
        const maintenanceItem = this.maintenanceDefine.find(o => key === o.name)
        if (maintenanceItem) temp[maintenanceItem.dataIndex] = value
      }
      this.maintenanceData.datasets[0].data = temp
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard {
  padding: 9px 26px 0;
  .dashboard-block {
    margin-bottom: 44px;
    .title {
      font-size: map-get($fontSize, large);
      font-weight: 600;
      color: $mainFontColor;
      padding: 0 0 16px;
      text-align: start;
    }
    .block-wrap {
      display: flex;
      .block {
        &.connectors-status {
          flex: 5.3;
        }
        &.maintenance-status {
          flex: 4.7;
        }
        border: 1px solid $borderDark1;
        border-radius: 8px;
        padding: 16px;
        box-sizing: border-box;
        &:not(:last-child) {
          margin-right: 24px;
        }
        .block-title {
          text-align: start;
          margin-bottom: 16px;
          font-weight: 600;
          color: $subFontColor;
        }
        .block-content {
          display: flex;
          >div {
            flex: 1;
          }
          .left.doughnut-wrap {
            padding: 18px;
            .doughnut {
              position: relative;
              width: 250px;
              height: 250px;
              .doughnut-middle-text {
                width: 100%;
                height: 100%;
                position: absolute;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                pointer-events: none;

                .num {
                  font-size: map-get($fontSize, xx-large);
                  font-weight: 600;
                  color: $mainFontColor;
                  margin-bottom: 6px;
                }
                .description {
                  color: $subFontColor;
                }
              }
            }
          }

          .right {
            display: flex;
            align-items: center;
            .status-list {
              margin-left: 30px;
              width: 130px;
            }
            .status-item {
              display: flex;
              justify-content: space-between;
              align-items: center;
              &:not(:last-child) {
                margin-bottom: 15px;
                &.maintenance-status-item {
                margin-bottom: 11px;
                }
              }
              .label {
                display: flex;
                align-items: center;
                .label-color {
                  width: 12px;
                  height: 12px;
                }
                .label-name {
                  margin-left: 9px;
                  i:hover {
                    cursor: pointer;
                  }
                }
              }
              .num {
                font-size: map-get($fontSize, x-large);
                font-weight: 600;
              }
            }
          }
        }
      }
    }

    &.ampere-detail {
      .head {
        display: flex;
        position: relative;
        .title {
          padding-bottom: 23px;
          &:hover {
            cursor: pointer;
          }
          i {
            margin-left: 8px;
          }
        }
        .day-btn {
          position: absolute;
          right: 0;
          bottom: 13px;
          border-color: $mainFontColor;
          color: $mainFontColor;
          &.hide-input {
            ::v-deep .el-input__inner {
              width: 0px;
              padding: 0;
              cursor: pointer !important;
            }
          }
          &.hide-input .el-date-editor {
            position: absolute;
            top: 0;
            left: 0;
            opacity: 0;
            width: 0;
          }
        }
      }
      .block-wrap-overflow {
        .test-wrap {
          width: 100%;
          overflow-x: scroll;
          .block-title {
            color: $mainFontColor;
            font-weight: normal;
          }
          .bar-wrap {
            width: fit-content;
          }
        }
      }
    }
  }

  .day {
    display: flex;
  }
  ::v-deep .el-table {
    @include basicTable(false);
  }
}

</style>
